<template>
  <div :class="_class">
    <slot></slot>
  </div>
</template>
<script>

  const name = 'hive-button-group';
  export default {
    name,
    data() {
      return {

      };
    },
    computed: {
      _class() {
        return [
          `${name}`,
        ];
      },
    },
  };
</script>
